import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmt-separator',
  templateUrl: 'rmt-separator.html'
})
export class RmtSeparatorComponent {
  @Input() order;
  @Input() centerText;
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-separator/rmt-separator.ts